import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Placeholder signup: stores signups in the site database.
// Swap the axios.post below for a MailerLite embed/API call when ready.
const NewsletterForm = ({ source = "letters", compact = false, testid = "newsletter" }) => {
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!firstName.trim() || !email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, {
        first_name: firstName.trim(),
        email: email.trim(),
        source,
      });
      setDone(true);
      toast.success("You’re on the list. Welcome.");
    } catch {
      toast.error("Something didn’t go through. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <p data-testid={`${testid}-success`} className="font-serif italic text-xl text-deepteal">
        Thank you, {firstName.trim()}. Something quiet is on its way to you.
      </p>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid={`${testid}-form`}
      className={compact ? "flex flex-col gap-3" : "flex flex-col sm:flex-row gap-3 max-w-xl"}
    >
      <label className="sr-only" htmlFor={`${testid}-first-name`}>First Name</label>
      <input
        id={`${testid}-first-name`}
        data-testid={`${testid}-first-name-input`}
        type="text"
        required
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        placeholder="First Name"
        className="flex-1 bg-transparent border border-stone px-5 py-3.5 text-sm text-charcoal placeholder:text-taupe/70 focus:outline-none focus:border-teal transition-colors duration-500"
      />
      <label className="sr-only" htmlFor={`${testid}-email`}>Email Address</label>
      <input
        id={`${testid}-email`}
        data-testid={`${testid}-email-input`}
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email Address"
        className="flex-1 bg-transparent border border-stone px-5 py-3.5 text-sm text-charcoal placeholder:text-taupe/70 focus:outline-none focus:border-teal transition-colors duration-500"
      />
      <button
        type="submit"
        data-testid={`${testid}-submit-button`}
        disabled={loading}
        className="bg-teal text-ivory text-xs uppercase tracking-[0.25em] px-8 py-3.5 hover:bg-deepteal transition-colors duration-500 disabled:opacity-60"
      >
        {loading ? "Joining…" : "Join Tara’s Letters"}
      </button>
    </form>
  );
};

export default NewsletterForm;
